import CancelableApi from "./CancelableApi";
import CancelableAxiosInstance from "./CancelableAxiosInstance";

export interface ImageResult {
  thumbnailPath: string;
  path: string;
}

export default class ImageResultApi extends CancelableApi {
  static with(axios: CancelableAxiosInstance) {
    return new ImageResultApi(axios);
  }

  queryImageResults(studyId: string): Promise<ImageResult[]> {
    return this.client.get("/ai-results?studyId=" + studyId).then((resp) => resp.data);
  }
}
